var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"vid":_vm.vid,"name":_vm.$attrs.label,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('div',{staticClass:"block"},[_vm._t("default"),_c('p',{staticClass:"has-text-danger has-text-left is-size-7"},[_vm._v(_vm._s(errors[0]))])],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }